import { Form } from "components";

export function Filters({
  filters,
  onChange,
  onClean,
  inputValue,
  onInputValueChange,
  inputDiscount,
  onInputDiscountChange,
  inputTitle,
  onInputTitleChange,
}) {
  return (
    <Form>
      <div className="row">
        <Form.Field className="col-md-4">
          <Form.Label>Título</Form.Label>
          <Form.CreatableSelect
            placeholder='Digite o texto e pressione "Enter"'
            options={filters.title}
            onChange={(value) => onChange("title", value)}
            onInputChange={onInputTitleChange}
            inputValue={inputTitle}
          />
        </Form.Field>

        <Form.Field className="col-md-4">
          <Form.Label>Pontos</Form.Label>
          <Form.CreatableSelect
            placeholder='Digite um valor e pressione "Enter"'
            options={filters.value}
            onChange={(value) => onChange("value", value)}
            onInputChange={onInputValueChange}
            inputValue={inputValue}
          />
        </Form.Field>

        <Form.Field className="col-md-4">
          <Form.Label>Valor</Form.Label>
          <Form.CreatableSelect
            placeholder='Digite um valor e pressione "Enter"'
            options={filters.discount}
            onChange={(value) => onChange("discount", value)}
            onInputChange={onInputDiscountChange}
            inputValue={inputDiscount}
          />
        </Form.Field>
      </div>

      <div className="row text-center">
        <Form.Field>
          <Form.Button
            type="button"
            className="button-clean-filter margin-top-0"
            onClick={onClean}
          >
            Resetar filtros
          </Form.Button>
        </Form.Field>
      </div>
    </Form>
  );
}
